
function clickEvents() {
	document.addEventListener('click', event => {
		const linkParent = event.target.closest('.js-link-parent');
		const noBubble = event.target.classList.contains('js-link-no-bubble') || event.target.closest('.js-link-no-bubble');

		if (linkParent && !noBubble) {
			// link clicked
			const link = linkParent.querySelector('.js-link');
			if (link) {
				link.click();
			}
		}
	});
}

export default () => {
	clickEvents();
}
